import { Link } from "react-router-dom";
import { EMAIL } from "../config";
const Footer = () => {
  return (
    <footer className="footer">
      <ul className="footer__links-wrapper">
        <div className="footer__logo">
          <img
            loading="lazy"
            className="logo-written"
            src="/assets/logos/logo-written-white-1x.webp"
            srcSet="/assets/logos/logo-written-white-1x.webp 128w, /assets/logos/logo-written-white-2x.webp 256w, /assets/logos/logo-written-white-3x.webp 384w, /assets/logos/logo-written-white-4x.webp 512w, /assets/logos/logo-written-white--mobile-1x.webp 64w, /assets/logos/logo-written-white--mobile-2x.webp 128w, /assets/logos/logo-written-white--mobile-3x.webp 192w, /assets/logos/logo-written-white--mobile-4x.webp 256w"
            sizes="(max-width: 600px) 64px, (max-width: 1024px) 128px, (min-width: 1025px) 128px"
            alt="brand's written white logo"
          />
        </div>
        <ul className="footer__links-wrapper__links">
          <li>
            <Link to="/legal/tou">Terms of Use</Link>
          </li>
          <li>
            <Link to="/legal/pp">Privacy Policy</Link>
          </li>
          <li>
            <a href={EMAIL} aria-label="Email us at contact@hiko.com">
              Contact Us
            </a>
          </li>
        </ul>
      </ul>
    </footer>
  );
};

export default Footer;
